import React, { useCallback } from 'react';
import { useSelector }        from 'react-redux';
import { 
  goAssuredImage, 
  bluSmartImage, 
  electricVehicleImage, 
  cabNotProvidedImage, 
  cabDelayedImage 
}                             from '../../config/constants';
import { bluSmartTgpSeletor } from '../../pages/SearchPage/redux/selector';
import * as S                 from './BluSmartModalStyle'
interface IBluSmartModal {
  dbgData           : any
  setShowMoreModal  : (value : boolean) => void
}

const BluSmartModal : React.FC<IBluSmartModal> = ({
  dbgData = {},
  setShowMoreModal
}) => {
  const bluSmartData  = useSelector(bluSmartTgpSeletor);
  const { flat = "" , minutes = "" ,times = "" } = dbgData
  const { topElement = {}, secondElement = {}, subTitleLeft = "", subtitleRight = "", title = "" } = bluSmartData

// closing bluSmart modal
  const handleEvMore = () => { 
    if (setShowMoreModal) {
      setShowMoreModal(false)
    }
  };

  // replacing the string with respected values
  const replaceTgpData = useCallback(
    (str) => {
      return str?.replace('|FLAT|',flat)?.replace('|MINUTES|',minutes)?.replace('|TIMES|',times)
    },[]
  );

  return (
    <>
      <S.bgDrop onClick={handleEvMore}></S.bgDrop>
      <S.evCabPopup>
        <span className='close' onClick={handleEvMore}>&nbsp;</span>
        <div className='heading'>
          <S.GoAssuredModalImg src={goAssuredImage}/>
            <span className='font16 appendLeft10 makeFlex'>
              <S.ElectricVehicleImg src={electricVehicleImage}/>
              <span className='appendLeft10 text-white'>{title}</span>
            </span>
            <span className='makeFlex hrtlCenter rightInfo'>
              Fulfilled by
              <span className='logoWrap appendLeft10'>
                <S.BluSmartModalImg src={bluSmartImage}/>
              </span>
            </span>
        </div>
        <p className='refundTittle'>
          {replaceTgpData(subTitleLeft)} {subtitleRight}
        </p>
        <S.SprList>
          <li>
            <span className='iconWrap'>
              <S.CabConditionImg src={cabNotProvidedImage}/>
            </span>
            <div>
              <h3>{replaceTgpData(topElement?.title)}</h3>
              <p className='appendBottom16 desText'>{replaceTgpData(topElement?.subTitle)}</p>
              <h4>Refund Amount</h4>
              <p className='voucherText'><strong>{replaceTgpData(topElement?.refundTitle)}</strong></p>
              <p className='validText'>{replaceTgpData(topElement?.refundSubTitle)}</p>
            </div>
          </li>
          <li>
            <span className='iconWrap'>
              <S.CabConditionImg src={cabDelayedImage}/>
            </span>
            <div>
              <h3>{replaceTgpData(secondElement?.title)}</h3>
              <p className='appendBottom16 desText'>{replaceTgpData(secondElement?.subTitle)}</p>
              <h4>Refund Amount</h4>
              <p className='voucherText'><strong>{replaceTgpData(secondElement?.refundTitle)}</strong></p>
              <p className='validText'>{replaceTgpData(secondElement?.refundSubTitle)}</p>
            </div>
          </li>
        </S.SprList>
        <div className='flex-cont'>
          <S.GetBtn  onClick={handleEvMore}> Got it</S.GetBtn>
        </div>
      </S.evCabPopup>
    </>
  );
};

export default BluSmartModal;